import { render, staticRenderFns } from "./SafetySuppliesOrderTableList.vue?vue&type=template&id=b8661f52&scoped=true&"
import script from "./SafetySuppliesOrderTableList.vue?vue&type=script&lang=js&"
export * from "./SafetySuppliesOrderTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8661f52",
  null
  
)

export default component.exports